import * as ngCore from '@angular/core'

/** Minimal color picker — no manual hex input */
@ngCore.Component({
  selector: 'atn-ds-colorpicker',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Label displayed above the color picker
   *
   * @default undefined
   */
  public readonly labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /** Currently selected color value */
  public readonly valueSg = ngCore.model<string | undefined>(undefined, {
    alias: 'value',
  })

  /**
   * Indicates whether colorpicker is disabled or not
   */
  public readonly disabledSg = ngCore.input<boolean | undefined>(false, {
    alias: 'disabled',
  })

  /** Handles color selection from native picker */
  public selectColorHandler(event: Event) {
    const el = event.target as HTMLInputElement | null
    const value = el?.value ?? ''
    this.valueSg.set(value || undefined)
  }
}
